import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { customerStories } from '../data/pagesData';
import { ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CustomerStoryPage = () => {
  const { slug } = useParams();
  const [story, setStory] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Try backend first, fallback to mock
    fetch(`${API}/customer-stories/${slug}`)
      .then(r => r.json())
      .then(d => { if (d && d.title) setStory(d); else setStory(customerStories.find(s => s.slug === slug)); })
      .catch(() => setStory(customerStories.find(s => s.slug === slug)));
  }, [slug]);

  if (!story) return (
    <div className="bg-[#F9FBF5] min-h-screen">
      <Navbar />
      <div className="max-w-[800px] mx-auto px-6 py-32 text-center">
        <h1 className="text-[#082900] text-3xl font-serif mb-4">Story not found</h1>
        <Link to="/customers" className="text-[#082900] underline font-inter">Back to Customer Stories</Link>
      </div>
      <Footer />
    </div>
  );

  return (
    <div className="bg-[#F9FBF5] min-h-screen">
      <Navbar />
      <article className="max-w-[800px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-20">
        <Link to="/customers" className="inline-flex items-center gap-2 text-[#082900]/60 text-sm font-inter hover:text-[#082900] transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Customer Stories
        </Link>
        <div className="flex items-center gap-3 mb-4">
          <span className="text-[#082900]/50 text-sm font-inter">{story.company}</span>
          <span className="text-[#082900]/30">&middot;</span>
          <span className="text-[#082900]/50 text-sm font-inter">{story.industry}</span>
          <span className="text-[#082900]/30">&middot;</span>
          <span className="text-[#082900]/50 text-sm font-inter">{story.readTime}</span>
        </div>
        <h1 className="text-[#082900] text-[36px] lg:text-[48px] font-serif leading-tight mb-8">{story.title}</h1>
        {story.result && (
          <div className="bg-[#EAE5D9] rounded-xl p-6 mb-8">
            <p className="text-[#082900] text-sm font-semibold font-inter uppercase tracking-wide mb-1">Key Result</p>
            <p className="text-[#082900] text-xl font-serif">{story.result}</p>
          </div>
        )}
        <div className="rounded-2xl overflow-hidden mb-10">
          <img src={story.image} alt={story.title} className="w-full h-auto object-cover" />
        </div>
        <div className="prose-alex">
          {(story.content || story.excerpt).split('\n\n').map((p, i) => (
            <p key={i} className="text-[#082900]/80 text-base lg:text-lg font-inter leading-[1.8] mb-6">{p}</p>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-[#082900]/10">
          <Link to="/demo" className="inline-block px-8 py-4 bg-[#082900] text-white text-base font-medium rounded-full hover:bg-[#0A3900] transition-colors font-inter">Request a Demo</Link>
        </div>
      </article>
      <Footer />
    </div>
  );
};

export default CustomerStoryPage;
